import * as React from "react";
import styles from "./styles.scss";
import { useAiChatAssistantHooks } from "app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-hooks";
import { Link } from "react-router-dom";
import { routeConstants } from "app/routes/route-constants";
import { useEffect } from "react";
import { ChatInput } from "app/components/ai-chat-assistant/components/chat-input";
import { ChatMessages } from "app/components/ai-chat-assistant/components/chat-messages";
import { ChatFooter } from "app/components/ai-chat-assistant/components/chat-footer";

export const AiChatAssistant = ({
  setChatAssistantActive
}: {
  setChatAssistantActive?: () => void;
}) => {
  const {
    caseDraftCreation,
    running,
    messages,
    inputText,
    setInputText,
    send,
    endRef,
    clearChat,
    abortChat,
    translation,
    registerCase,
    canRegisterCase,
    onKeyDown
  } = useAiChatAssistantHooks();

  const hasChatMessages = messages?.length > 0;

  useEffect(() => {
    if (!hasChatMessages && inputText.trim().length > 0) {
      setChatAssistantActive?.();
    }
  }, [inputText, setChatAssistantActive, hasChatMessages]);

  if (!caseDraftCreation) {
    return null;
  }

  return (
    <div className={styles.chatShell}>
      {hasChatMessages && (
        <ChatMessages
          messages={messages}
          running={running}
          endRef={endRef}
          translation={translation}
        />
      )}
      <ChatInput
        inputText={inputText}
        setInputText={setInputText}
        send={send}
        running={running}
        translation={translation}
        abortChat={abortChat}
        onKeyDown={onKeyDown}
      />
      {!hasChatMessages ? (
        <div>
          <Link
            to={routeConstants.selectCaseType}
            className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}
          >
            {translation.textRegisterNewCase}
          </Link>
        </div>
      ) : null}
      {hasChatMessages && (
        <ChatFooter
          clearChat={clearChat}
          registerCase={registerCase}
          translation={translation}
          canRegisterCase={canRegisterCase}
        />
      )}
    </div>
  );
};
